<template>
  <div
    class="FormToggleSwitch"
    :class="{active: value}"

    @click="$emit('input', !value)"
  >
    <span
      class="ball"
      :class="{active: value}"
    ></span>
  </div>
</template>

<script>

export default {
  props: ['value'],
}

</script>

<style scoped>

.FormToggleSwitch {
  display: inline-block;
  border-radius: 500px;
  height: 22px;
  width: 40px;
  position: relative;
  transition-duration: .15s;
  background-color: rgb(233, 233, 233);
  cursor: pointer;
  padding: 4px;
}

.ball {
  position: absolute;
  display: block;
  width: 16px;
  background-color: white;
  box-shadow: 1px 1px 3px rgba(0,0,0,.2);
  border-radius: 500px;
  height: 16px;
  transform: translateY(-50%) translateX(0);
  top: 50%;
  transition-duration: .15s;
}

.active.ball {
  transform: translateY(-50%) translateX(100%);
  box-shadow: 1px 1px 3px transparent;
}

.FormToggleSwitch.active {
  background-color: var(--apple-green);
}

</style>
